import NumberFlow from "@number-flow/react"
import { Card, Flex, Statistic, Typography } from "antd"

import InfoTooltip from "../../../../Components/InfoTooltip/InfoTooltip"
import Private from "../../../../Components/Private"
import { useAnimatedNumber } from "../../../../hooks/useAnimatedNumber"

import "./styles.less"

const { Text } = Typography

const formatCompareValue = (value, stat) => {
  if (value == null) return null
  const num = Number(value)
  if (Number.isNaN(num)) return String(value)
  const digits = stat.precision || 0
  const formatted = num.toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  })
  return `${stat.prefix || ""}${formatted}${stat.suffix || ""}`
}

const StatisticsCard = ({ stat = {}, comparisonLabel, className = "", ...cardProps }) => {
  const animatedValue = useAnimatedNumber(stat.value)
  const compareValue = stat.comparison_value
  const compareFormatted = formatCompareValue(compareValue, stat)
  // Only the monetary card ("Chargeback fees saved", the sole block the backend sends with a "$"
  // prefix) is hidden in Incognito mode — counts and rates stay readable (CHA1-1357).
  const isMoneyStat = stat.prefix === "$"
  return (
    <Card className={`statistics-card ${className}`} {...cardProps}>
      <Statistic
        title={
          <Flex gap={8} align="flex-start" className="statistics-card-title">
            <Text
              type="secondary"
              strong
              className="statistics-card-title-text"
              style={{ margin: 0, letterSpacing: "-0.36px" }}
              ellipsis={{ tooltip: stat.title }}
            >
              {stat.title}
            </Text>
            {stat.tooltip && <InfoTooltip title={stat.tooltip} placement="top" />}
          </Flex>
        }
        value={animatedValue}
        precision={stat.precision || 0}
        suffix={stat.suffix}
        prefix={stat.prefix}
        formatter={(value) => (
          <Private disabled={!isMoneyStat}>
            <NumberFlow
              value={Number(value) || 0}
              format={{
                minimumFractionDigits: stat.precision || 0,
                maximumFractionDigits: stat.precision || 0
              }}
            />
          </Private>
        )}
        valueStyle={{
          fontSize: "24px",
          fontWeight: 400,
          lineHeight: 1.4
        }}
      />
      {compareFormatted != null && (
        <Text type="secondary" className="statistics-card-compare">
          <Private disabled={!isMoneyStat}>{compareFormatted}</Private>{" "}
          {comparisonLabel || "previous period"}
        </Text>
      )}
    </Card>
  )
}

export default StatisticsCard
